var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgQuestionMark(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 8.5,
    stroke: "#3DA2FF",
    strokeOpacity: 0.4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.1094 13.6602H12.7734V13.5C12.7734 12.8086 13.0586 12.4766 13.6484 12.125C14.3984 11.6836 14.8945 11.1172 14.8945 10.1836C14.8945 8.76562 13.7266 8 12.1172 8C10.6484 8 9.4375 8.73047 9.41406 10.3711H11.2109C11.2227 9.82813 11.6367 9.5 12.1016 9.5C12.5625 9.5 12.9297 9.80859 12.9297 10.2734C12.9297 10.75 12.5586 11.0547 12.0703 11.3672C11.4492 11.7656 11.1133 12.1758 11.1094 13.5V13.6602ZM11.9727 16.2227C12.5078 16.2227 12.9805 15.7695 12.9883 15.207C12.9805 14.6523 12.5078 14.2031 11.9727 14.2031C11.4102 14.2031 10.9492 14.6523 10.957 15.207C10.9492 15.7695 11.4102 16.2227 11.9727 16.2227Z",
    fill: "#3DA2FF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestionMark);
export default __webpack_public_path__ + "static/media/question-mark.3bcdbd6abf46d11a735f34d9f966715f.svg";
export { ForwardRef as ReactComponent };